import {useTranslation, TKey} from '@/translations/i18n.tsx'
import {useParsedSearchParams} from '@hooks/useParsedSearchParams.ts'
import {AssignmentsURLParams} from '@features/home/types.ts'
import {CheckIcon} from '@components/ui/icon'
import {Dialog, DialogClose, DialogContent} from '@components/ui/dialog'
import {ModalCloseButton, ModalHeader} from '@components/ui/modal-atoms'
import {Button} from '@components/ui/button'
import {cn} from '@utilities/helpers'

const searchParamsToFilter = {
    coordination: [
        {name: 'commons:listing', sortName: 'title'},
        {name: 'commons:area', sortName: 'address'},
        {name: 'dashboard:calendar:table:host', sortName: 'first_name'},
        {name: 'home:table:proposed_dates', sortName: 'host_availability_dates'},
        {name: 'home:coordination_status', sortName: 'coordination_status'}
    ],
    pending_submission: [
        {name: 'commons:listing', sortName: 'title'},
        {name: 'commons:area', sortName: 'address'},
        {name: 'dashboard:calendar:table:host', sortName: 'first_name'},
        {name: 'commons:assignment_date', sortName: 'to_shoot_at'}
    ],
    needs_more_assets: [
        {name: 'commons:listing', sortName: 'title'},
        {name: 'commons:area', sortName: 'address'},
        {name: 'dashboard:calendar:table:host', sortName: 'first_name'},
        {name: 'home:table:need_more_assets_date', sortName: 'assets_rejected_at'},
        {name: 'home:table:reason', sortName: 'declined_reason_notes'}
    ],
    upcoming: [
        {name: 'commons:listing', sortName: 'title'},
        {name: 'commons:area', sortName: 'address'},
        {name: 'dashboard:calendar:table:host', sortName: 'first_name'},
        {name: 'home:table:scheduled_for', sortName: 'to_shoot_at'}
    ],
    completed: [
        {name: 'commons:listing', sortName: 'title'},
        {name: 'dashboard:calendar:table:host', sortName: 'first_name'},
        {name: 'commons:completed_at', sortName: 'completed_at'},
        {name: 'commons:amount', sortName: 'amount'},
        {name: 'commons:status', sortName: 'status'}
    ]
} as const satisfies Record<
    AssignmentsURLParams['filter_value'],
    {name: TKey; sortName: AssignmentsURLParams['order_by']}[]
>

export const TableSortingMobileModal = ({onClose}: {onClose: () => void}) => {
    const {t} = useTranslation()
    const {searchParams, setSearchParams} = useParsedSearchParams(AssignmentsURLParams)

    const onClickFilter = (sortName: AssignmentsURLParams['order_by']) => {
        setSearchParams({order_by: sortName})
        onClose()
    }
    return (
        <Dialog open={true} onOpenChange={onClose}>
            <DialogContent className="w-[361px]" showCloseButton={false}>
                <ModalHeader className="py-2.5 px-2 border-none grid grid-cols-[40px_1fr_40px]">
                    <DialogClose data-slot="dialog-close" render={<ModalCloseButton />} />

                    <div className="flex justify-center items-center">
                        <h3>{t('commons:sort_by')}</h3>
                    </div>
                </ModalHeader>

                <div className="py-4 px-3 flex flex-col gap-1">
                    {searchParamsToFilter[searchParams.filter_value].map(filter => (
                        <Button
                            variant={'ghost'}
                            className={cn(
                                'justify-between items-center rounded-md w-full py-2.5 px-2',
                                searchParams.order_by == filter.sortName && 'bg-neutral-100'
                            )}
                            onClick={() => onClickFilter(filter.sortName)}
                        >
                            {t(filter.name)}{' '}
                            {searchParams.order_by == filter.sortName && (
                                <CheckIcon size={20} className="text-primary-600" />
                            )}
                        </Button>
                    ))}
                </div>
            </DialogContent>
        </Dialog>
    )
}
